import React, { useState } from 'react';
import { View } from 'react-native';
import theme from '../../../theme';
import Nav from '../Nav';
import AgentsPricingHero from './AgentaPricingHero';
import AgentsPriceCards from './AgentsPricingCards';
import { CTA } from '../CTA';
import { Footer } from '../Footer';
import {Faq} from '../Faq';

const AgentsPricing = (props) => {

    const [period, setPeriod] = useState('monthly');
    const [responseStatus, setResponseStatus] = useState(null);

    async function submitHandler(formData) {
        const API_URL = "https://bx9x6sd0rf.execute-api.eu-central-1.amazonaws.com/prod/form_submit";

        try {
            const response = await fetch(API_URL, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                name: formData.name,
                email: formData.email,
                title: formData.jobTitle,
                company: formData.company,
                website: "", 
            }),
            });

            const data = await response.json();
            setResponseStatus(response.status);
            return data;
            } catch (err) {
            setResponseStatus(0)
            throw err;
            }
        }

    const pricingFaqData = [
    { q: 'What counts as a "token"?', a: 'Roughly 750 words of query + response text. Most questions use 200–800 tokens end to end.' },
    { q: 'What happens if we go over our included tokens?', a: "You're billed per million tokens — queries are never blocked." },
    { q: 'What if I want tighter control on costs?', a: "You can pre-pay tokens and restrict usage when caps are hit." },
    { q: 'Can we switch between monthly and annual?', a: 'Yes — switch to annual anytime and we prorate the remainder of your current cycle.' }
    ];

  return (
    <View style={{ width: '100%', backgroundColor: theme.colors.surfacePage }}>

      <Nav/>
      <Section style={{ borderBottomWidth: 1, borderBottomColor: theme.colors.borderDefault }} />
        <AgentsPricingHero period={period} onPeriodChange={setPeriod} />
        <AgentsPriceCards period={period} submitHandler={submitHandler} responseStatus={responseStatus} onGetStarted={(tag) => {/* TODO: route to signup, tag = 'Standard' | 'Enterprise' */}} />

      <Section />
        <Faq
            data={pricingFaqData}
            header="Pricing FAQ"
        />

      <Section />
        <CTA 
            submitHandler={submitHandler}
            responseStatus={responseStatus}
            heading="Still deciding? Talk to user about your usage."
            buttonLabel="Book a Demo"
        />


      <Section style={{ borderTopWidth: 1, borderTopColor: theme.colors.borderSubtle }} />


      <Footer/>

    </View>
  );

}

const Section = ({ style, children }) => (
  <View style={[{ width: '100%' }, style]}>{children}</View>
);

export default AgentsPricing